export const hasFlpAccessToDataProperty = (dataProperty, requiredPermissionLevel = 'read-write') => {
  var _dataProperty$metadat;
  const accessLevel = (_dataProperty$metadat = dataProperty.metadata) === null || _dataProperty$metadat === void 0 || (_dataProperty$metadat = _dataProperty$metadat.typeDefinition) === null || _dataProperty$metadat === void 0 || (_dataProperty$metadat = _dataProperty$metadat.fieldLevelPermission) === null || _dataProperty$metadat === void 0 ? void 0 : _dataProperty$metadat.accessLevel;
  if (requiredPermissionLevel === 'read-write') {
    return accessLevel === '' || accessLevel === 'not_specified';
  }
  if (requiredPermissionLevel === 'read') {
    return accessLevel === '' || accessLevel === 'not_specified' || accessLevel === 'read_only';
  }
  return true;
};